import { Injectable } from '@angular/core';
import { mspTableConfigInterface, mspTableHeaderI } from '../msp-table.component';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';

@Injectable({
	providedIn: 'root',
})
export class MspTableService {
	private getTableConfigUrl = environment.baseApiUrl + 'mspTable';
	private getTableColumnsUrl = environment.baseApiUrl + 'mspTable/column';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	_allowedTableViewType = ['table', 'box'];
	_allowedItemsPerPage = [10, 20, 50];

	mspTableConfig: mspTableConfigInterface = {
		itemsPerPage: 10,
		tableViewType: 'table',
	};

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {
		try {
			if (localStorage.getItem('mspTableConfig') == undefined) throw '';
			const mspTableConfig = JSON.parse(localStorage.getItem('mspTableConfig'));
			if (this._allowedItemsPerPage.includes(mspTableConfig['itemsPerPage']))
				this.mspTableConfig.itemsPerPage = mspTableConfig['itemsPerPage'];
			if (this._allowedTableViewType.includes(mspTableConfig['tableViewType']))
				this.mspTableConfig.tableViewType = mspTableConfig['tableViewType'];
		} catch {
			this.queryTableConfig().subscribe((tableConfig) => {
				this.setTableConfig('itemsPerPage', tableConfig.itemsPerPage);
				this.setTableConfig('tableViewType', tableConfig.tableViewType);
			});
		}
	}

	queryTableConfig(): Observable<mspTableConfigInterface> {
		return this.http.get<mspTableConfigInterface>(this.getTableConfigUrl, { headers: this.headers });
	}

	getTableConfig(configItem?: 'tableViewType' | 'itemsPerPage'): any {
		try {
			return configItem ? this.mspTableConfig[configItem] : this.mspTableConfig;
		} catch {}
	}

	setTableConfig(configItem: 'tableViewType' | 'itemsPerPage', value: any): void {
		if (configItem == 'tableViewType' && this._allowedTableViewType.includes(value)) this.mspTableConfig[configItem] = value;
		if (configItem == 'itemsPerPage' && this._allowedItemsPerPage.includes(value)) this.mspTableConfig[configItem] = value;
		localStorage.setItem('mspTableConfig', JSON.stringify(this.mspTableConfig));
	}

	saveTableConfig(): Observable<mspTableConfigInterface> {
		return this.http.post<mspTableConfigInterface>(
			this.getTableConfigUrl,
			{ itemsPerPage: this.mspTableConfig.itemsPerPage, tableViewType: this.mspTableConfig.tableViewType },
			{ headers: this.headers }
		);
	}

	getTableColumns(source: 'request', solutionArea?: string): Observable<string[]> {
		const parameters: any = { source: source };
		if (solutionArea) parameters.id_solution_area = solutionArea;
		return this.http.get<string[]>(this.getTableColumnsUrl, { headers: this.headers, params: parameters });
	}

	setTableColumns(source: 'request', header: mspTableHeaderI[], solutionArea?: string): Observable<any> {
		const parameters: { [k: string]: any } = { source: source, columns: header.join(',') };
		if (solutionArea) parameters.id_solution_area = solutionArea;

		return this.http.post(this.getTableColumnsUrl, parameters, { headers: this.headers });
	}
}
